import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../shared/environments/environment';
import {Params} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class ReportService {

    constructor(private http: HttpClient) {}

    saveReport(query: Params): Observable<Blob> {
        // Указываем responseType как 'blob' для получения бинарных данных
        return this.http.get(`${environment.API_BASE_PATH}/worker-load/report`, {
            params: query,
            responseType: 'blob',
        });
    }

}
